var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('div',{staticClass:"auth h-100"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"auth--content"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_vm._v(" "),_c('div',{staticClass:"auth--footer"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth--header"},[_c('img',{attrs:{"src":"/img/logo_grey.png","alt":""}})])
}]

export { render, staticRenderFns }